<!-- 路由列表页面（这个是后端那边的路由） -->
<template>
<div>
	<!-- 标题 -->
	<div class="page-title">路由列表</div>
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 15px;position: sticky;left: 30px;z-index: 5;width: 860px;">
		<div style="font-size: 16px;margin-right: 15px;">已选择{{routeData.length}}项</div>
		<a-button @click="addButton" style="" type="primary">设置路由组</a-button>
		
		<a-button @click="syncButton" style="margin-left: 20px;" type="primary">同步路由</a-button>
		
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			
			<div class="table-th-cell"
			:style="{'width':60 + 'px'}">
				<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
			</div>
			
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<!-- 选择 -->
			<div class="table-td-cell" :style="{'width':60 + 'px'}">
				<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
			</div>
			<!-- ID -->
			<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
				{{item.id}}
			</div>
			<!-- 路由名称 -->
			<div class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
				{{item.name}}
			</div>
			<!-- 路由URL -->
			<div class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
				{{item.uri}}
			</div>
			<!-- 路由前缀 -->
			<div class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
				{{item.prefix}}
			</div>
			<!-- 控制器 -->
			<div class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}">
				{{item.controller}}
			</div>
			<!-- 方法 -->
			<div class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}">
				{{item.action}}
			</div>
			<!-- 请求方法 -->
			<div class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}">
				{{item.method}}
			</div>
			<!-- 路由组 -->
			<div class="table-td-cell" :style="{'width':rableTitle[7].width + 'px'}">
				{{item.group}}
			</div>
			<!-- 操作 -->
			<div @click="editTable(index,item)" class="table-td-cell" :style="{'width': rableTitle[8].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
				编辑
			</div>
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
	</div>
	
	<!-- 分页 -->
	<div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 30px;">
		
		<a-pagination v-model="r_page" :pageSize="20" :total="table_total" @change="paginationChange" hideOnSinglePage />
		
	</div>
	
	
	<!-- 新增/编辑的侧边栏 -->
	<a-drawer
	  :title="drawer_title"
	  width="450px"
	  placement="right"
	  :closable="false"
	  :visible="visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 10px;">
			
			<div class="form-cell-box">
				<div class="class-title">路由名称</div>
					
				<a-input v-model="x_name" placeholder="请输入" style="width: 260px;"  />
			</div>
			
			<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 20px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>
	
	</a-drawer>
	
	<a-modal v-model="route_modal" title="设置路由组" okType="primary" width="700px"
	  okText="确认" cancelText="取消"
	  @ok="routeOk" :confirmLoading="route_loading">
	    <div style="">
			<div style="display: flex;align-items: center;">
				<div style="margin-right: 20px;">路由组名称</div>
					
				<a-input v-model="x_route_name" placeholder="请输入" style="width: 260px;"  />
			</div>
			<div style="color: red;height: 30px;margin-left: 90px;margin-top: 5px;">{{x_route_name_hint}}</div>
			<div style="margin-bottom: 10px;">已选的路由：</div>
			<div style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
				<div v-for="(item,index) in routeData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 15px;" class="">
					<div style="width: 80px;text-align: right;">id：{{item.id}}</div>
					<span style="margin: 0 5px;"> — </span>
					<div style="width: 195px;">{{item.name}}</div>
				</div>
			</div>
			
			<!-- <div class="">id：4 —— 李永润</div> -->
		</div>
	</a-modal>
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
	
</div>
</template>

<script>
import { routeList, routeEditName, routeSync, routeGroupName } from '@/request/api'
export default {
	name: 'routes_',
	components: {
		
	},
	data() {
		return {
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:80, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"路由名称", width:180, type:"name", },
				{title:"路由URL", width:240, type:"uri", },
				{title:"路由前缀", width:120, type:"prefix", },
				{title:"控制器", width:260, type:"controller", },
				{title:"方法", width:200, type:"action", },
				{title:"请求方法", width:100, type:"method", },
				{title:"路由组", width:140, type:"group", },
				{title:"操作", width:80, type:"cz", },
			],
			tableShowData: [],
			table_scroll_width: 1200,
			
			search_button_loading: false,
			r_search:"",
			r_page: 1,
			table_total: 0,
			
			drawer_title: "新增", // 侧边栏标题
			visible: false,
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			add_form_hint: "", // 侧边栏新增表单的验证提示
			
			// 多选
			indeterminate: false,
			checkAll: false,
			selected_number: 0, // 已选数量
			
			x_id: "", // 编辑的路由id
			x_name: "", // 编辑的路由名字	
			x_index: "", // 选择编辑的index
			
			routeData: [], // 选中的，要进行路由分组的数据
			route_modal: false,
			route_loading: false,
			
			x_route_name: "", // 设置的路由组名称
			x_route_name_hint: "", // 内容为空提示
		}
	},
	mounted(){
		let that = this
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30 + 60
		
		that.searchButton()
		
	},
	methods:{
		// 搜索
		searchButton(){
			let that = this
			
			that.search_button_loading = true
			
			routeList({page: that.r_page}).then(res=>{
				console.log("列表",res.data.data)
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					let data = res.data.data.data
					data.forEach(res=>{
						res.checked = false
					})
					
					if(that.routeData.length > 0){
						let ccc = true
						let iii = 0
						data.forEach(res=>{
							that.routeData.forEach(res_r=>{
								if(res.id === res_r.id){
									res.checked = true
									ccc = false
									iii = iii + 1
								}
							})	
						})
						console.log("iii",iii)
						if(iii === 20){ // 全选
							that.indeterminate = false
							that.checkAll = true
						}
						else {
							if(ccc){
								that.checkAll = false
								that.indeterminate = false
							}
							else {
								that.checkAll = false
								that.indeterminate = true
							}
						}
						
					}
					else {
						console.log("that.checkAll",that.checkAll)
						that.checkAll = false
						that.indeterminate = false
					}
					
					that.tableShowData = data
					that.table_total = res.data.data.total
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		},
		// 新增
		addButton(){
			let that = this
			// that.drawer_title = "新增"
			
			if(that.routeData.length > 0){
				that.route_modal = true
				
				
			}
			
		},
		// 编辑
		editTable(index,item){
			console.log(index)
			let that = this
			that.drawer_title = "编辑"
			
			that.x_id = item.id
			that.x_name = item.name
			that.x_index = index
			
			that.visible = true
		},
		// 侧边栏的新增/编辑
		addRequest(){
			let that = this
			if(!that.x_name){
				that.add_form_hint = "请输入路由名称"
			}
			else {
				that.add_form_hint = ""
				that.add_button_loading = true
				
				routeEditName({
					id: that.x_id,
					name: that.x_name,
				}).then(res=>{
					console.log("修改",res)
					that.add_button_loading = false
					that.tableShowData[that.x_index].name = that.x_name
					that.onCloseDrawer()
					
				})
			}
			
		},
		// 侧边栏关闭
		onCloseDrawer(){
			if(this.add_button_loading){ // 新增中或编辑中不准关闭侧边栏
				return
			}
			this.visible = false
			
			this.x_id = ""
			this.x_name = ""
			
			this.add_form_hint = ""
		},
		
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton()
			
		},
		
		// 多选测试
		onChangeCheckbox(checkedList,index) {
			let that = this
			if(that.tableShowData[index].checked){ // 为选中状态，然后要改为未选中状态
				that.tableShowData[index].checked = false
				
				let iii
				console.log("that.tableShowData[index].id",that.tableShowData[index].id)
				that.routeData.forEach((res,index_z)=>{
					
					if(res.id == that.tableShowData[index].id){
						iii = index_z
					}
				})
				that.routeData.splice(iii,1)
				console.log("iii",iii)
			}
			else { // 未选中状态改为选中状态
				that.tableShowData[index].checked = true
				if(that.routeData.length === 0){
					that.routeData.push(that.tableShowData[index])
				}
				else {
					// 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
					let ddd = true
					for(let i = 0; i < that.routeData.length; i++){
						if(that.routeData[i].id === that.tableShowData[index].id){
							ddd = false
							break;
						}
					}
					if(ddd){
						that.routeData.push(that.tableShowData[index])
					}
				}
			}
		    // that.tableShowData[index].checked = !that.tableShowData[index].checked
			console.log("that.routeData",that.routeData)
			let ccc = true 
			let iii = false
			let nnn = that.routeData.length || 0
			console.log("that.routeData.length",that.routeData.length);
			that.tableShowData.forEach(res=>{
				if(res.checked){
					iii = true
					// nnn = nnn + 1
					
				}
				if(!res.checked){
					ccc = false
				}
			})
			// console.log("nnn",nnn)
			if(ccc){
				that.indeterminate = false
			}
			else {
				that.indeterminate = iii
			}
			that.checkAll = ccc
			that.selected_number = nnn
		},
		// 全选
		onCheckAllChange(e) {
			let that = this
			if(that.checkAll){
				that.tableShowData.forEach(res=>{
					res.checked = false
				})
				that.checkAll = false
				// that.selected_number = 0
				
				that.routeData = [] // 取消全选的时候，全部清除
			}else {
				that.tableShowData.forEach(res=>{
					res.checked = true
					// 有重复的就不要传了
					let ddd = true
					that.routeData.forEach(res_r => {
						if(res_r.id === res.id){
							ddd = false
							console.log("l",ddd)
						}
					})
					
					if(ddd){
						console.log("w",ddd)
						that.routeData.push(res)
					}
				})
				// that.selected_number = that.tableShowData.length
				that.indeterminate = false
				that.checkAll = true
				
			}
			
		},
		
		// 一键同步路由
		syncButton(){
			let that = this
			that.search_button_loading = true
			routeSync().then(res=>{
				console.log("一键同步路由",res)
				that.search_button_loading = false
				that.$message.success('同步成功');
				that.r_page = 1
				that.searchButton()
			})
		},
		
		// 组合路由确认按钮
		routeOk(){
			let that = this
			if(that.x_route_name.length > 0){
				that.route_loading = true
				that.x_route_name_hint = ""
				
				let r_ids = []
				that.routeData.forEach(res=>{
					r_ids.push(res.id)
				})
				console.log(r_ids);
				routeGroupName({
					ids: r_ids,
					group_name: that.x_route_name
				}).then(res=>{
					console.log("组合路由按钮",res)
					that.route_loading = false
					that.route_modal = false
					that.$message.success('设置成功');
					that.routeData = []
					that.searchButton()
				})
			}
			else {
				that.x_route_name_hint = "输入名称"
			}
			
		}
	}
}
</script>

<style scoped>
.page-title {
	text-align: left;
	font-weight: 500;
	font-size: 24px;
}


/* 表格部分的样式 */
.table-th {
	position:sticky;
	top: 65px;
	z-index:3;
	display: flex;
	align-items: center;
	background-color: #fbfbfb;
	border-bottom: 1px solid #e8e8e8;
}
.table-th-cell {
	display: flex;
	align-items: center;
	padding: 12px;
	cursor: default;
	color: #060606;
	flex-shrink: 0;
	user-select: none;
}

.table-td {
	
	display: flex;
	align-items: center;
	width: 100%;
	border-bottom: 1px solid #e8e8e8;
}
.table-td:hover {
	background-color: #eff9ff;
}
.table-td:hover .table-td-cell-sticky{
	background-color: #eff9ff;
}
.table-td-cell {
	padding: 12px;
	flex-shrink: 0;
	cursor: default;
	word-break: break-all;
	color: rgba(0, 0, 0, 0.65);
	min-height: 45px;
	font-size: 13px;
	/* overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis; */
}

/* 侧边栏 */
.form-cell-box {
	display: flex;
	align-items: center;
	margin-bottom: 20px;
}
.class-title {
	font-size: 14px;
	margin-right: 25px;
	width: 80px;
	color: #333;
	text-align: right;
}

.loading-box {
	position: fixed;
	width: 100%;
	height: 100vh;
	left: 0;
	top: 0;
	z-index: 111;
	text-align: center;
	line-height: 100vh;
}
</style>